import { render } from "./EventDetailsList.vue?vue&type=template&id=2d3bd606"
import script from "./EventDetailsList.vue?vue&type=script&lang=js"
export * from "./EventDetailsList.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__